import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import titleCase from "title-case";

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    margin: theme.spacing.unit,
    height: 32,
  },
  alignRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
});

class FormToolBar extends React.Component {
  handleDiscard = () => {
    this.props.history.goBack();
  };

  render() {
    const { classes, moduleName, isEditing } = this.props;

    const formTitlePrefix = !isEditing ? "Create" : "Edit";

    return (
      <div className={classes.root}>
        <Grid container spacing={24} alignItems="center">
          <Grid item xs={8}>
            <Typography component="h2" variant="h5" gutterBottom>
              {moduleName === 'scheduler' && 'Schedule Notification'}
              {moduleName !== 'scheduler' && `${formTitlePrefix} ${titleCase(moduleName)}`}

            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.alignRight}>
            {moduleName !== 'scheduler' && <IconButton aria-label="Close" onClick={this.handleDiscard}>
              <CloseIcon />
            </IconButton>}
          </Grid>
        </Grid>
      </div>
    );
  }
}

FormToolBar.propTypes = {
  moduleName: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired,
};

export default compose(
  withRouter,
  withStyles(styles)
)(FormToolBar);
